import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from "vue";

import { Ctx } from "@/components/FormContent/FormContent";
import {
  openForm,
  relativeTime,
  formatDate,
} from "@/components/FormContent/methods";


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
  item: {
    type: Object,
    default: () => ({}),
  },
  params: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



const isMobile = computed(
  () => getCurrentInstance()?.proxy.$vuetify.breakpoint.mobile
);

function click() {
  props.item.new = false;
  const { formname, filter } = props.params;
  if (props.item.nmbr) {
    filter.nmbr = props.item.nmbr;
  }
  openForm({} as Ctx, { formname: props.item.formname, filter }, null);
}

return { __sfc: true,props, isMobile, click, relativeTime, formatDate }
}

})